import { QueryClientProvider } from "@tanstack/react-query";
import type { JSX, ReactNode } from "react";
import { queryClient } from "./query-client";

// Pure passthrough — the QueryClient is a module-level singleton
// (see `./query-client.ts`) so it's never recreated on re-render.
export function QueryProvider({ children }: { children: ReactNode }): JSX.Element {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
